import { loadSession } from "./session";
import { API_URL, SALON_TIMEZONE } from "./trpc";

/**
 * Télécharge un fichier servi par l'API hors tRPC (PDF, export).
 *
 * Un simple lien ne suffit pas : le poste du salon s'authentifie par en-tête
 * `Bearer`, qu'une balise `<a href>` n'envoie pas. On passe donc par `fetch`,
 * puis par un blob.
 */
export async function downloadFromApi(path: string, fileName: string): Promise<void> {
  const session = loadSession();
  const reponse = await fetch(`${API_URL}${path}`, {
    headers: session ? { authorization: `Bearer ${session.token}` } : {},
  });
  if (!reponse.ok) throw new Error(`Téléchargement impossible (${reponse.status}).`);

  const url = URL.createObjectURL(await reponse.blob());
  const lien = document.createElement("a");
  lien.href = url;
  lien.download = fileName;
  lien.click();
  // Sans révocation, le blob reste en mémoire jusqu'au rechargement.
  URL.revokeObjectURL(url);
}

/** Saisie « 45 » ou « 45,50 » → centimes ; `null` si illisible. */
export function parseEuros(saisie: string): number | null {
  const valeur = Number.parseFloat(saisie.replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(valeur) ? Math.round(valeur * 100) : null;
}

/** « 2026-10-11 » → « 11 oct. 2026 ». */
export function formatDay(day: string | Date | null | undefined): string {
  if (!day) return "—";
  const date = typeof day === "string" ? new Date(`${day}T12:00:00Z`) : day;
  return new Intl.DateTimeFormat("fr-FR", {
    timeZone: SALON_TIMEZONE,
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}
